import { React, useState } from 'react'
import { StyleSheet, css } from 'aphrodite'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import backgroundImage from '../../assets/maker-viewer.jpg'
import tooltipWhite from '../../assets/tooltip-white.png'
import LayoutCol from '../../components/Layout/LayoutCol'
import WidgetHomeHeader from '../../components/Widget/WidgetHomeHeader'
import { COLOR_WHITE } from '../../lib/colors'
import UIButton from '../../components/UI/UIButton'
import {
  IconFleche,
  IconFacebook,
  IconInstagram,
  IconLinkedin,
  IconYoutube,
} from '../../components/Icon/'
import UILink from '../../components/UI/UILink'
import LayoutRow from '../../components/Layout/LayoutRow'
import WidgetMotionDesign from '../../components/Widget/WidgetMotionDesign'
import SwiperCore, { Autoplay } from 'swiper'
SwiperCore.use([Autoplay])
import 'swiper/css'
import INT from '../../config/index'
import makerThumb from '../../assets/maker.jpg'

const styles = StyleSheet.create({
  separator: {
    width: '100%',
    minHeight: '10px',
    backgroundColor: COLOR_WHITE,
  },
  smallSeparator: {
    '@media (max-width: 480px)': {
      margin: '10px 0 10px 0',
    },
  },
  container: {
    display: 'flex',
    width: '100vw',
    height: '100vh',
    overflow: 'hidden',
    position: 'relative',
  },
  flex: {
    display: 'flex',
    height: '100%',
  },
  customContainer: {
    width: '100vw',
    position: 'relative',
    height: 'auto',
  },
  backgroundImage: {
    objectFit: 'cover',
    width: '100vw',
    height: '100vh',
    '@media (max-width: 480px)': {
      width: '100vw',
    },
  },
  navbar: {
    position: 'absolute',
    zIndex: 10,
    width: '100vw',
  },
  content: {
    position: 'absolute',
    zIndex: 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    color: COLOR_WHITE,
    '@media (max-width: 992px)': {
      top: '50%',
      transform: 'translateY(-50%)',
    },
  },
  title: {
    fontSize: '10vw',
    margin: '0px',
    padding: '0px',
    textDecorationColor: 'white',
    textUnderlineStyle: 'solid',
  },
  subtitle: {
    letterSpacing: '-0.05em',
    fontSize: '3vw',
    margin: '0px',
    padding: '0px',
    '@media (max-width: 480px)': {
      fontSize: '5vw',
    },
  },
  tooltip: {
    position: 'relative',
    display: 'flex',
    width: 'auto',
    justifyContent: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    margin: '80px 0px 30px 0px',
    cursor: 'pointer',
    '@media (max-width: 480px)': {
      margin: '0px',
      marginTop: '25px',
      position: 'relative',
      boxShadow:
        '0px 0px 1px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05)',
      borderRadius: '50px',
      left: '50%',
      height: '57px',
      width: '90vw',
      bottom: '7.5%',
      transform: 'translateX(-50%)',
      background: '#fff',
      marginBottom: '20px',
    },
  },
  tooltipImg: {
    '@media (max-width: 480px)': {
      position: 'absolute',
      width: '20px',
      top: '50%',
      transform: 'translateY(-50%)',
      left: '5%',
    },
  },
  tooltipText: {
    fontWeight: 600,
    fontSize: '18px',
    margin: '0px',
    width: '100%',
    position: 'absolute',
    textAlign: 'center',
    color: '#08ABAF',
    zIndex: 5,
    padding: '10px 100px',
    alignSelf: 'center',
    whiteSpace: 'nowrap',
    '@media (max-width: 480px)': {
      textAlign: 'center',
      left: '0',
      fontSize: '4vw',
      color: '#A0AEC0',
      fontWeight: 500,
      padding: '10px 0',
    },
  },
  button: {
    borderRadius: '50px',
    backgroundColor: '#08ABAF',
    color: COLOR_WHITE,
    padding: '10px 30px',
    fontWeight: 700,
    letterSpacing: '-0.05em',
    border: '3px solid #FFFFFF',
    '@media (max-width: 480px)': {
      width: '90vw',
    },
  },
  smallLayout: {
    '@media (max-width: 480px)': {
      height: '50vh',
      width: '100vw',
    },
    width: '100%',
  },
  text: {
    fontWeight: 700,
    letterSpacing: '-0.05em',
    fontSize: '18px',
    whiteSpace: 'nowrap',
    margin: '0px auto',
  },
  socialMedia: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '2em',
    '@media (max-width: 480px)': {
      marginTop: '4em',
    },
  },
  icon: {
    width: '40px',
    margin: '7px',
  },
  icon2: {
    width: '50px',
    margin: '7px',
  },
  swipe: {
    backgroundColor: '#EC503D',
  },
  scrollIcon: {
    position: 'absolute',
    bottom: 10,
    zIndex: 2,
    left: '50%',
    transform: 'translateX(-50%)',
  },
  viewerThumb: {
    width: '280px',
    position: 'absolute',
    right: '30px',
    bottom: '30px',
    zIndex: '25',
    cursor: 'pointer',
  },
})

const Landscape = () => {
  const { t } = useTranslation('translation')
  const navigate = useNavigate()
  const [isViewerModalOpened, setViewerModalOpened] = useState(false)

  return (
    <>
      <WidgetHomeHeader
        smallSize={window.innerWidth < 480}
        dynamicStyle={styles.navbar}
      />
      <LayoutRow className={css(styles.container)}>
        <LayoutCol col={12} dynamicStyle={styles.flex}>
          <img
            src={backgroundImage}
            className={css(styles.backgroundImage)}
            alt="background image"
            width="100%"
            height="100%"
          />
          <div className="arrowDown">
            <IconFleche />
          </div>
        </LayoutCol>
        <div className={css(styles.content)}>
          <h1 className={css(styles.title)}>{t('pages.beAMaker.title')}</h1>
          <div className={css(styles.separator, styles.smallSeparator)} />
          {window.innerWidth > 480 ? (
            <>
              <span className="cestquoimaker">
                <div
                  id="creation-compte-maker-header"
                  className={css(styles.tooltip)}
                  disabled={!INT.AUTH_PERM}
                  onClick={() => {
                    setViewerModalOpened(true)
                  }}
                >
                  <img
                    src={tooltipWhite}
                    alt="tooltip submit my request"
                    width="auto"
                    height="auto"
                  />
                  <p className={css(styles.tooltipText)}>
                    {t('pages.beAMaker.whatIsAMaker')}
                  </p>
                </div>
              </span>
              <span className="makerheaderjeminscris">
                <UIButton
                  id="creation-compte-maker-banner"
                  label={t('pages.beAMaker.signIn')}
                  dynamicStyle={styles.button}
                  textStyle={styles.text}
                  onClick={() => {
                    if (INT.AUTH_PERM === true) {
                      navigate('/register-maker')
                    }
                  }}
                />
              </span>
              <WidgetMotionDesign
                isModalOpened={isViewerModalOpened}
                setModalOpened={setViewerModalOpened}
                video={'/assets/maker.mp4'}
              />
            </>
          ) : (
            <>
              <span className="cestquoimaker">
                <div
                  id="creation-compte-maker-header"
                  className={css(styles.tooltip)}
                  disabled={!INT.AUTH_PERM}
                  onClick={() => {
                    setViewerModalOpened(true)
                  }}
                >
                  <p
                    className={css(styles.tooltipText)}
                    style={{ left: '0% !important' }}
                  >
                    {t('pages.beAMaker.whatIsAMaker')}
                  </p>
                </div>
              </span>
              <span className="makerheaderjeminscris">
                <UIButton
                  id="creation-compte-maker-banner"
                  label={t('pages.beAMaker.signIn')}
                  dynamicStyle={styles.button}
                  textStyle={styles.text}
                  onClick={() => {
                    if (INT.AUTH_PERM === true) {
                      navigate('/register-maker')
                    }
                  }}
                />
              </span>
              <WidgetMotionDesign
                isModalOpened={isViewerModalOpened}
                setModalOpened={setViewerModalOpened}
                video={'/assets/maker.mp4'}
              />
            </>
          )}
          <div className={css(styles.socialMedia)}>
            <UILink
              socialIcon={<IconFacebook dynamicStyle={styles.icon} />}
              redirection={
                'https://www.facebook.com/profile.php?id=100085535453086'
              }
              linkStyle="socialMedia"
            />
            <UILink
              socialIcon={<IconLinkedin dynamicStyle={styles.icon} />}
              redirection={
                'https://www.linkedin.com/company/ubiqeyes/?viewAsMember=true'
              }
              linkStyle="socialMedia"
            />
            <UILink
              socialIcon={<IconInstagram dynamicStyle={styles.icon} />}
              redirection={'https://www.instagram.com/ubiqeyes/'}
              linkStyle="socialMedia"
            />
            <UILink
              socialIcon={<IconYoutube dynamicStyle={styles.icon2} />}
              redirection={'https://www.youtube.com/@ubiqeyes'}
              linkStyle="socialMedia"
            />
          </div>
        </div>
        {window.innerWidth > 480 && (
          <div
            onClick={() => {
              setViewerModalOpened(true)
            }}
          >
            <img
              className={css(styles.viewerThumb)}
              src={makerThumb}
              alt="tooltip be a maker"
              width="auto"
              height="auto"
            />
          </div>
        )}
      </LayoutRow>
    </>
  )
}

export default Landscape
